module.exports = __webpack_public_path__ + "static/media/keyboard.da73c3b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/keyboard.png
// module id = 92
// module chunks = 0